module.exports = __webpack_public_path__ + "img/bg_error.b8cad709.png";